import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const getAllMenu = async () => {
    try {
        const response = await axios.get(`${baseURL}/menu/list`);
      //  console.log('esto traigo en servicio de menu:', response.data);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error(error.message || 'Ocurrió un error');
    }
};